import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA } from './utils/GoogleAnalytics/gatracking';
import { BrowserRouter } from "react-router-dom";

// jwt_token is httpOnly, sent only via cookies — the browser only attaches
// cookies to cross-origin requests (React dev server vs Node on a different
// port locally; same-origin in real deployments regardless) when
// withCredentials is set. Without this, Node never sees the cookie and the
// AK-injection middleware silently has nothing to inject.
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
initGA()
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
